import axios from "axios";

export const dashboardService = {
  fetchDashboard,
};

function fetchDashboard(id, options) {
  return axios.get("/v1/dashboard", {params: { ...options }});
}
